// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.7.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.7.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".EventRedirectAlert-module__redesignedEventReport--RwRD6{display:flex;background-color:var(--xm-main-background-color);margin-bottom:1rem}.EventRedirectAlert-module__redesignedEventReport--RwRD6 .EventRedirectAlert-module__alert--Yo712{display:flex;flex:1;justify-content:space-between}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"redesignedEventReport": "EventRedirectAlert-module__redesignedEventReport--RwRD6",
	"alert": "EventRedirectAlert-module__alert--Yo712"
};
export default ___CSS_LOADER_EXPORT___;
